"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var get_parameter_by_name = void 0;

get_parameter_by_name = function get_parameter_by_name(name) {
  var regex = void 0;
  var results = void 0;
  name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
  regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
  results = regex.exec(location.search);
  if (results === null) {
    return null;
  } else {
    try {
      return decodeURIComponent(results[1].replace(/\+/g, " "));
    } catch (e) {
      console.error(e);
      return null;
    }
  }
};

exports.default = get_parameter_by_name;